import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "korio_cookie_consent";
const GTM_ID = "GTM-P8DG5BDD";

function loadGTM() {
  if (window.__gtmLoaded) return;
  window.__gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const f = document.getElementsByTagName("script")[0];
  const j = document.createElement("script");
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + GTM_ID;
  f.parentNode.insertBefore(j, f);
}

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    if (choice === "accepted") loadGTM();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (choice) return null;

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setChoice(value);
    if (value === "accepted") loadGTM();
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 120, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 120, opacity: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="fixed inset-x-0 bottom-0 z-[120] p-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md md:p-0"
        data-testid="cookie-banner"
      >
        <div className="rounded-2xl border border-white/10 bg-korio-elevated/95 p-6 shadow-2xl backdrop-blur-xl">
          <div className="flex items-center gap-3">
            <span className="brand-gradient flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full text-white">
              <Cookie size={20} />
            </span>
            <h3 className="font-display text-lg font-medium tracking-tight text-white">We value your privacy</h3>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            We use analytics cookies to understand how you use our site and improve your experience.
            You can accept or decline — essential functionality works either way.
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="brand-gradient flex-1 rounded-full px-5 py-3 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Accept
            </button>
            <button
              data-testid="cookie-decline"
              onClick={() => decide("declined")}
              className="flex-1 rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white/5"
            >
              Decline
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
